const preparePartnerAreas = (data) => {
    const searchResult = data?.searchResult || {};
    
    const filters = searchResult?.filters || {};
    
    const partnerAreas = filters.partnerAreas || [];
    
    return partnerAreas;
}

export default preparePartnerAreas;